export const domainMapping = {
  "Phonological Awareness": {
    abbreviation: "PA",
    color: "var(--domain-phonological_awareness)",
  },
  Decoding: { abbreviation: "D", color: "var(--domain-decoding)" },
  "High Frequency Words": {
    abbreviation: "HFW",
    color: "var(--domain-high_frequency_words)",
  },
  "Background Knowledge": {
    abbreviation: "BK",
    color: "var(--domain-background_knowledge)",
  },
  Vocabulary: { abbreviation: "V", color: "var(--domain-vocabulary)" },
  "Structures and Reasoning": {
    abbreviation: "SR",
    color: "var(--domain-structures_and_reasoning)",
  },
};

export const getDomainFromMapping = (val: string) => {
  let domainName = domainMapping[val as keyof typeof domainMapping] || {
    abbreviation: val,
    color: "gray",
  };
  // adding ability to pass domain as the abbreviation
  let key = "";
  if (domainName.color === "gray") {
    const foundKey = Object.keys(domainMapping).find(
      (k) => domainMapping[k as keyof typeof domainMapping].abbreviation === val
    );
    if (foundKey) {
      domainName = domainMapping[foundKey as keyof typeof domainMapping];
      key = foundKey;
    }
  }
  return { ...domainName, fullname: key ? key : val };
};
